module.exports = __webpack_public_path__ + "static/media/3U.d16591bc.png";